import React, { Fragment } from 'react'
import { Box, Button, Grid, Typography, Divider, } from '@mui/material';
import Iconify from '../../components/iconify';

export default function FreeTrial() {

    const styles = {
        heading: {
            fontFamily: "Sofia Sans Extra Condensed",
            fontSize: "24px",
            fontWeight: 700,
            // lineHeight: "60px",
            // letterSpacing: "0em",
            textAlign: "justify",
            "@media (max-width: 600px)": {
                fontSize: "28px", // Adjust the font size for smaller screens
                textAlign: "center",
            },
        },
        typography: {
            fontFamily: "Sofia Sans Extra Condensed",
            fontSize: "50px",
            fontWeight: 700,
            lineHeight: "60px",
            letterSpacing: "0em",
            textAlign: "center",
            "@media (max-width: 600px)": {
                fontSize: "32px", // Adjust the font size for smaller screens
                textAlign: "center",
                lineHeight: "38px",
            },
        },
        title: {
            fontFamily: "Roboto Flex",
            color: '#1D53E7',
            fontSize: "18px",
            fontWeight: 600,

        },
        text: {
            fontFamily: "Roboto Flex",
            fontSize: "16px",
            fontWeight: 400,

        },
        // Other styles...
    };
    return (
        <Fragment>
            <Box sx={{ p: 2, backgroundColor: '#F1F1F1', borderRadius: 5, }}>

                <Typography
                    sx={{
                        color: "#1E53E8",
                        ...styles.heading,
                    }}
                >
                    YOUR PLAN DETAILS
                </Typography>
                <Box mb={3} mt={2} sx={{ p: { xs: 0, md: 2 } }}>

                    <Typography
                        sx={{
                            ...styles.typography,
                            color: "#1E53E8",
                            zIndex: 2,
                            textTransform: "uppercase", p: 2,
                        }}
                    >
                        ENTHUSIAST PLAN
                    </Typography>
                    <Box
                        rowGap={2}
                        columnGap={3}
                        display="grid"
                        gridTemplateColumns={{
                            xs: 'repeat(1, 1fr)',
                            sm: 'repeat(1, 1fr)',
                        }}
                    >
                        <Grid item container spacing={{ md: 2 }} >
                            <Grid item xs={4} md={2} sx={{ color: 'text.body1', ...styles.title }}>
                                Plan Status :
                            </Grid>
                            <Grid item
                                xs={8}
                                md={9}
                                sx={{ typography: 'subtitle2', ...styles.text }}
                            >
                                Inactive
                                {/* {isActive ? "Active" : "Inactive"}{" "}   */}
                                <span
                                    style={{
                                        fontWeight: 600,
                                        fontSize: "22px",
                                        color: "#F03D55"
                                        // color: isActive ? "#27AE60" : "#F03D55",
                                    }}
                                >
                                    {" "}
                                    ●{" "}
                                </span>
                            </Grid>

                        </Grid>
                        <Divider sx={{ m: 0, p: 0 }} color="#D9D9D9" />
                        <Grid item container spacing={{ md: 2 }}  >
                            <Grid item xs={4} md={2} sx={{ color: 'text.body1', ...styles.title }}>
                                Validity :
                            </Grid>
                            <Grid item
                                xs={8}
                                md={9}
                                sx={{ typography: 'subtitle2', ...styles.text }}
                            >
                                30 Days Remaining
                            </Grid>
                        </Grid>
                        <Divider sx={{ m: 0, p: 0 }} color="#D9D9D9" />
                        <Grid item container spacing={{ md: 2 }} >
                            <Grid item xs={4} md={2} sx={{ color: 'text.body1', ...styles.title }}>
                                Monthly :
                            </Grid>
                            <Grid item
                                xs={8}
                                md={9}
                                sx={{ typography: 'subtitle2', ...styles.text }}
                            >
                                ₹799 + GST
                            </Grid>
                        </Grid>
                        <Divider sx={{ m: 0, p: 0 }} color="#D9D9D9" />
                        <Grid item container spacing={{ md: 2 }} >
                            <Grid item xs={4} md={2} sx={{ color: 'text.body1', ...styles.title }}>
                                Features :
                            </Grid>
                            <Grid item
                                xs={8}
                                md={9}
                                spacing={3}
                                sx={{ typography: 'subtitle2', ...styles.text }}
                            >
                                <Box
                                    sx={{
                                        display: "grid",
                                        rowGap: 2,
                                        columnGap: 3,
                                        gridTemplateColumns: {
                                            xs: "repeat(1, 1fr)",
                                            sm: "repeat(1, 1fr)",
                                            md: "repeat(2, 1fr)",
                                        },
                                    }}
                                >
                                    <Typography variant="body2" sx={{ display: 'flex', alignItems: 'flex-start', mb: 1, ...styles.text }}>
                                        <Iconify icon="mdi:tick" minWidth="1.5rem" minHeight="1.5rem" color='green' />
                                        &nbsp; 8 vCores AMD EPYCTM (up to 2.25 GHz)
                                    </Typography>
                                    <Typography variant="body2" sx={{ display: 'flex', alignItems: 'center', mb: 1, ...styles.text }}>
                                        <Iconify icon="mdi:tick" minWidth="1.5rem" minHeight="1.5rem" color='green' />
                                        &nbsp; Windows 10 Pro
                                    </Typography>
                                    <Typography variant="body2" sx={{ display: 'flex', alignItems: 'center', mb: 1, ...styles.text }}>
                                        <Iconify icon="mdi:tick" minWidth="1.5rem" minHeight="1.5rem" color='green' />
                                        &nbsp; 12GB RAM
                                    </Typography>
                                    <Typography variant="body2" sx={{ display: 'flex', alignItems: 'center', mb: 1, ...styles.text }}>
                                        <Iconify icon="mdi:tick" minWidth="1.5rem" minHeight="1.5rem" color='green' />
                                        &nbsp; Up to 1Gbps Internet Speed
                                    </Typography>
                                    <Typography variant="body2" sx={{ display: 'flex', alignItems: 'center', mb: 1, ...styles.text }}>
                                        <Iconify icon="mdi:tick" minWidth="1.5rem" minHeight="1.5rem" color='green' />
                                        &nbsp; 256GB Storage
                                    </Typography>
                                </Box>
                            </Grid>


                        </Grid>
                    </Box>

                    {/* Renew or Upgrade Button */}
                    <Box

                        sx={{
                            mt: 4,
                            display: "grid",
                            rowGap: 2,
                            columnGap: 3,
                            gridTemplateColumns: {
                                xs: "repeat(1, 1fr)",
                                sm: "repeat(1, 1fr)",
                                md: "repeat(2, 1fr)",
                            },
                        }}
                    >
                        <Button
                            variant="contained"
                            size='large'
                            fullWidth
                            sx={{
                                p: 1,
                                backgroundColor: '#FFFFFF',
                                color: 'blue',
                                fontWeight: 'bold',
                                width: '100%',
                                // maxWidth: '400px',
                                borderRadius: '5',
                                textTransform: "none",
                                '&:hover': {
                                    backgroundColor: '#blue',
                                    // transform: 'scale(1.05)',
                                    color: "white",
                                    fontWeight: 600,
                                },
                            }}
                        >
                            Renew
                        </Button>
                        <Button
                            variant="contained"
                            size='large'
                            fullWidth
                            sx={{
                                p: 1,
                                backgroundColor: '#C7F760',
                                color: 'blue',
                                fontWeight: 'bold',
                                width: '100%',
                                // maxWidth: '400px',
                                borderRadius: '5',
                                textTransform: "none",
                                '&:hover': {
                                    backgroundColor: '#blue',
                                    // transform: 'scale(1.05)',
                                    color: "white",
                                    fontWeight: 600,
                                },
                            }}
                        >
                            Upgrade
                        </Button>
                    </Box>


                </Box>



            </Box>
        </Fragment>
    )
}
